export default __webpack_public_path__ + "static/media/bg-our-loans.8df0e09d.png";